/**
---
title: BadgeLink
...

# BadgeLink


## Variations (add as extraClasses)
badge--small
badge--transparent


## Related
Badge


## Examples / Usage

basic:
`<BadgeLink href="http://www.example.com" extraClasses="badge--small my-optional-extra-class">Example Badge</BadgeLink>`

with subtext:
`<BadgeLink href="http://www.example.com" subText="Subtext:">Example Badge</BadgeLink>`

**/

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

export default class BadgeLink extends Component {
  render() {

    var { extraClasses, subText, badgeStyle, children, ...props } = this.props;

    const classNames = classnames(
      'badge',
      {
        "badge--transparent": badgeStyle == "transparent",
        "badge--white": badgeStyle == "white"
      }
    );


    //Todo
    const extras = extraClasses ? extraClasses : '';
    const styles = {...getStyles('badge-a'), ...props.style}

    return(
      <a {...props} className={classNames + ' ' + extras} style={styles}>
        {getStyleTag(['badge-a', 'badge'])}
        {subText &&
          <span className="badge__subhead">{subText}</span>
        }
        <span className="badge__content" style={getStyles('badge__content')}>{children}</span>
      </a>
    )
  }
}


BadgeLink.propTypes = {
  subText: PropTypes.string,
  extraClasses: PropTypes.string
}



// WEBPACK FOOTER //
// ./webapp/components/elements/BadgeLink.js